import React, { FC } from 'react';

type Props = {
  classCss: string;
  props?: React.SVGProps<SVGSVGElement>;
};
const IconX: FC<Props> = ({ classCss, props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 19"
      className={classCss}
      {...props}
    >
      <polygon
        fillRule="evenodd"
        points="18.33 1.858 11.023 9.165 18.33 16.472 16.472 18.33 9.165 11.023 1.858 18.33 0 16.472 7.307 9.165 0 1.858 1.858 0 9.165 7.307 16.472 0"
      />
    </svg>
  );
};

export default IconX;
